import { Grid, Typography } from '@material-ui/core';
import React, { VFC } from 'react';
import { useIntl } from 'react-intl';

import { SettingSwitch } from '../../SettingSwitch';
import {
  SMS_BOT_ENABLED,
  T2A_BOT_ENABLED,
  WIDGET_BOT_ENABLED,
} from './constants';
import { messages } from './messages';
import { useStyles } from './styles';

export type BotPlatformTypes =
  | typeof SMS_BOT_ENABLED
  | typeof WIDGET_BOT_ENABLED
  | typeof T2A_BOT_ENABLED;

export interface BotPlatformToggleGroup {
  title: string;
  onToggle: (key: BotPlatformTypes) => () => void;
  platforms: { [platformKey: string]: boolean };
}

export const BotPlatformToggleGroup: VFC<BotPlatformToggleGroup> = ({
  title,
  onToggle,
  platforms,
}) => {
  const styles = useStyles();
  const intl = useIntl();

  return (
    <div>
      <Typography variant="body2" className={styles.header}>
        {title}
      </Typography>

      <Grid container className={styles.itemContainer} direction="row">
        {Object.keys(platforms).map(key => {
          const platformKey = key as BotPlatformTypes;

          return (
            <Grid item key={platformKey} className={styles.item}>
              <SettingSwitch
                key={platformKey}
                dataKey={platformKey}
                checked={platforms[platformKey]}
                onChange={onToggle(platformKey)}
                label={intl.formatMessage(messages[platformKey])}
              />
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};
